const header = document.querySelector('.site-header');

window.addEventListener('scroll', function () {
  let scrollY = window.scrollY;
  if (scrollY >= 100) {
    header.classList.add('is-scrolled');
  } else {
    header.classList.remove('is-scrolled');
  }
});
